import PropTypes from "prop-types";
import Avatar from "@/components/common/Avatar";
import CustomMoreOptions from "@/components/specific/Custom_More_Options";
import { Link } from "react-router-dom";
import { Dropdown } from "antd";

const ManifestoCard = ({
  id,
  title,
  date,
  author,
  avatar,
  status,
  onDelete,
  onModify,
}) => {
  const handleMenuClick = (menuItem, e) => {
    e?.domEvent?.stopPropagation();
    if (menuItem.key === "delete") {
      onDelete(id, title);
    } else if (menuItem.key === "modify") {
      onModify(id);
    }
  };

  // Function to truncate title
  const truncateTitle = (text, maxLength = 40) => {
    return text?.length > maxLength
      ? text?.substring(0, maxLength) + "..."
      : text;
  };

  return (
    <div className="rounded-lg shadow-sm p-3 bg-[var(--header-bg)] text-left">
      <div className="flex justify-between items-start">
        <Link to={`/dashboard/manifesto/${id}`} className="flex-1">
          <div className="flex flex-col items-start gap-1">
            <h3 className="text-bold-x text-lightestGrey whitespace-nowrap overflow-hidden text-ellipsis max-w-[250px]">
              {truncateTitle(title)}
            </h3>
            <p className="text-small text-lighterGrey">{date}</p>
            {(status === "Expired" || status === "Upcoming") && (
              <div className="flex items-center mt-1">
                <div
                  className={`w-2 h-2 rounded-full ${
                    status === "Expired" ? "bg-danger" : "bg-primary"
                  } mr-1`}
                />
                <p
                  className={`text-small ${
                    status === "Expired" ? "text-danger" : "text-primary"
                  } font-bold`}>
                  {status}
                </p>
              </div>
            )}
            <div className="flex items-center">
              <Avatar
                size={32}
                src={avatar}
                className="border-2 border-gray-100"
                alt={author}
              />
              <span className="text-regular text-lighterGrey">{author}</span>
            </div>
          </div>
        </Link>

        <Dropdown
          menu={{
            items: [
              {
                key: "modify",
                label: "Modify",
                onClick: (e) => handleMenuClick({ key: "modify" }, e),
              },
              {
                key: "delete",
                label: "Delete",
                onClick: (e) => handleMenuClick({ key: "delete" }, e),
              },
            ],
          }}
          trigger={["click"]}
          onClick={(e) => e.stopPropagation()}>
          <button className="p-2 " onClick={(e) => e.stopPropagation()}>
            <CustomMoreOptions variant="filled" orientation="vertical" />
          </button>
        </Dropdown>
      </div>
    </div>
  );
};

ManifestoCard.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  date: PropTypes.string,
  author: PropTypes.string,
  avatar: PropTypes.string,
  status: PropTypes.string,
  onDelete: PropTypes.func,
  onModify: PropTypes.func,
};

export default ManifestoCard;
